/*
  Property information dialog router.

  Note: This file is `.jsx` and should stay parseable in environments that
  don't enable experimental decorator syntax.
*/

import React, { useEffect, useState } from 'react'

import clsx from 'clsx'

// Centralized lodash imports - much cleaner!
import {
  map,
  round,
  isEmpty,
  isNil,
  padStart,
  head,
  find,
  slice,
  toLower,
  toUpper,
  merge,
  cloneDeep,
  forEach,
  filter,
  includes,
  concat,
  compact,
  isEqual,
  isArray,
  replace,
  isUndefined,
  kebabCase,
  orderBy,
  unset,
  set,
  get,
  remove} from '@/utils/lodash'

import { Avatar, Button, Card, CardActions, CardContent, CardHeader, Checkbox, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, FormControlLabel,  IconButton, InputAdornment, InputLabel, List, ListItem, ListItemText, Menu, MenuItem, Select, TextField, Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import withSession from '@/housefolios-components/Session/withSession'
import { enqueueSnackbar } from 'notistack'
import { NumericFormat } from 'react-number-format'
import { PacmanLoader } from 'react-spinners'
import BlockUi from 'react-block-ui'
import { DEFAULT_PREFERENCES } from '@/housefolios-components/OrganizationSettings/OrganizationPreferences'
import Autocomplete from '@mui/material/Autocomplete'
import { useQuery, useMutation, useLazyQuery } from '@apollo/client/react'
import {
  GET_COMPPROPERTIES,
  GET_PROPERTY} from '@/housefolios-components/PropertyContainer/queries'
import { UPDATE_PROPERTY } from '@/housefolios-components/PropertyContainer/mutations'
import { GET_ME } from '@/housefolios-components/Session/queries'
import { GET_ASSUMPTIONS } from '@/housefolios-components/AssumptionsSettings/quries'
import { DEFAULT_ANALYTICS } from '@/housefolios-components/Property/fragments'
import renderInputFieldsFunction from '@/housefolios-components/Functions/renderInput'
import {
  Compare,
  ExpandLess,
  ExpandMore,
  Tune} from '@mui/icons-material'
import CriticalFields from '../CriticalFields'
import SubtoPITICash from '../SubtoPITI/Cash/'
import SubtoPITICreative from '../SubtoPITI/Creative/'
import { useNavigate } from 'react-router'

function PropertyInformationDialogHandler(props) {
  const { open, onClose, property = {}, shared, url } = props

  let navigate = useNavigate()

  // Some list/grid contexts provide `id` instead of Mongo-style `_id`.
  // Apollo will drop `undefined` variables, so we must always resolve an ID
  // before triggering dialogs that auto-save (Pacemorby/Astroflip PITI flow).
  const resolvedPropertyId = property?._id || property?.id

  let preferences = merge(
    cloneDeep(DEFAULT_PREFERENCES),
    props?.session?.me?.activeOrg?.memberPreferences,
    props?.session?.me?.activeOrg?.preferences,
  )

  const propertyCriticalFieldCheck =
    !property?.propertyDashboard &&
    !shared &&
    preferences.general.completePropertyData
  const pitiDataCheck =
    (props?.session?.me?.activeOrg?.member === 'pacemorby' ||
      props?.session?.me?.activeOrg?.member === 'astroflip') &&
    !property?.pitiData &&
    property?.realeflowData

  const [openCriticalFields, setOpenCriticalFields] = useState(false)
  const [openPITICashData, setOpenPITICashData] = useState(false)
  const [openPITICreativeData, setOpenPITICreativeData] =
    useState(false)

  const handleCloseCriticalFields = () => {
    setOpenCriticalFields(false)
    navigate(url || '/property-details/' + resolvedPropertyId + '/Summary')
    onClose()
  }

  const handleClosePITICashData = (skip = false) => {
    setOpenPITICashData(false)
    if (propertyCriticalFieldCheck && !skip)
      setOpenCriticalFields(true)
    else {
      // navigate(url || '/property-details/' + property?._id + '/Summary')
      onClose()
    }
  }

  const handleClosePITICreativeData = (skip = false) => {
    setOpenPITICreativeData(false)
    if (propertyCriticalFieldCheck && !skip)
      setOpenCriticalFields(true)
    else {
      // navigate(url || '/property-details/' + property?._id + '/Summary')
      onClose()
    }
  }

  useEffect(() => {
    if (open) {
      if (!resolvedPropertyId) {
        onClose()
        return
      }
      if (pitiDataCheck) setOpenPITICreativeData(true)
      else if (propertyCriticalFieldCheck) setOpenCriticalFields(true)
      else {
        navigate(
          url || '/property-details/' + resolvedPropertyId + '/Summary',
        )
        onClose()
      }
    }
  }, [open])
  return (
    <>
      <SubtoPITICash
        open={openPITICashData}
        onClose={handleClosePITICashData}
        propertyId={resolvedPropertyId}
        address={property?.address}
        city={property?.city}
        state={property?.state}
        zipcode={property?.zip}
      />
      <SubtoPITICreative
        open={openPITICreativeData}
        onClose={handleClosePITICreativeData}
        propertyId={resolvedPropertyId}
        address={property?.address}
        city={property?.city}
        state={property?.state}
        zipcode={property?.zip}
      />
      <CriticalFields
        open={openCriticalFields}
        onClose={handleCloseCriticalFields}
        propertyId={resolvedPropertyId}
      />
    </>
  )
}

export default withSession(PropertyInformationDialogHandler)
